import {
  FALLBACK_IMAGE,
  BASE_URL,
  buildHomeDescription
} from '~/utils/seo/jsonLd'

/**
 * 홈 페이지 seoMeta 핸들러 (FO)
 * - API 호출 없음 (정적 메타만 생성)
 * - Organization + WebSite JSON-LD는 nuxt.config.js 전역 head에서 모든 페이지에 주입되므로
 *   여기서는 생략하여 홈 페이지 중복 출력을 방지한다.
 */
export default function handleHome ({ store }) {
  const description = buildHomeDescription()
  const canonicalUrl = BASE_URL

  store.commit('seoMeta/set', {
    title: '다이소몰 - 온라인 국민가게',
    description,
    ogUrl: canonicalUrl,
    ogImage: FALLBACK_IMAGE,
    ogType: 'website',
    canonical: canonicalUrl,
    mobileUrl: 'https://m.daisomall.co.kr/main/ds',
    h1: '다이소몰',
    jsonLd: []
  })
}
